import DataTypeModel from '../../../../models/DataType'
import { get, destroy, post, put } from '../../../methods'
import apiUrl from '../../../Url/ApiUrl'

export const getXtrfQuotes = (parameters, cancelToken) =>
    post(apiUrl.quotes.xtrfQuotes, DataTypeModel(parameters), cancelToken)

export const getXtrfQuote = (uriParams) => get(apiUrl.quotes.xtrfQuote, DataTypeModel({}, uriParams))

export const postXtrfQuotes = (bodyRequest) => post(apiUrl.quotes.xtrfNewQuote, DataTypeModel(bodyRequest))

export const acceptXtrfQuote = (uriParams) => put(apiUrl.quotes.xtrfAcceptQuote, DataTypeModel({}, uriParams))

export const declineXtrfQuote = (uriParams) => destroy(apiUrl.quotes.xtrfDeclineQuote, DataTypeModel({}, uriParams))

export const downloadXtrfPdfQuoteUrl = (uriParams) =>
    get(apiUrl.quotes.xtrfQuotedownloadPdf, DataTypeModel({}, uriParams))

export const getXtrfQuoteTasks = (uriParams) => get(apiUrl.quotes.xtrfQuoteTasks, DataTypeModel({}, uriParams))

export const getXtrfQuoteFiles = (uriParams) => get(apiUrl.quotes.xtrfQuoteFiles, DataTypeModel({}, uriParams))
